<template>
<div>

<!-- Generator: Adobe Illustrator 24.1.3, SVG Export Plug-In  -->
<svg id="nextprev" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.2 31.2" style="overflow:visible;enable-background:new 0 0 31.2 31.2;" xml:space="preserve">
<defs>
</defs>
<g>
	<circle class="st0" cx="15.6" cy="15.6" r="15.6"/>
	<polygon class="st1" points="8.3,15.7 18.9,26.3 18.9,5.1 	"/>
</g>
</svg>


    </div>
</template>


<script>
export default{

}

</script>


<style>
	.st0{fill:#FFFFFF;}
	.st1{fill:#F05D5B;}



#nextprev{
width: 36px;
height: 36px;
}
</style>